import { useTheme } from '@emotion/react';
import { useOverlayPosition, useTooltip as useTooltip$1 } from 'react-aria';
import { useTooltipTriggerState } from 'react-stately';
import { useTooltipContext } from './tooltip-context.js';

/**
 * Hook for building an accessible tooltip.
 *
 * @param options - Options for the hook.
 * @param ref - A ref to the underlying HTML element.
 */ function useTooltip(options, ref) {
    const { anchorRef, containerPadding = 'md', crossOffset = 0, defaultOpen, disabled, offset = 'xs', open, placement: defaultPlacement = 'top' } = options;
    const theme = useTheme();
    const parseSpacing = (value)=>typeof value === 'string' ? theme.spacings[value] : theme.scales.base * (value ?? 0);
    const contextState = useTooltipContext();
    const localState = useTooltipTriggerState({
        ...options,
        defaultOpen,
        isDisabled: disabled,
        isOpen: open
    });
    const state = open != null || defaultOpen != null || !contextState ? localState : contextState;
    const { overlayProps, placement } = useOverlayPosition({
        crossOffset: parseSpacing(crossOffset),
        containerPadding: parseSpacing(containerPadding),
        isOpen: state.isOpen,
        offset: parseSpacing(offset),
        overlayRef: ref,
        placement: defaultPlacement,
        targetRef: anchorRef
    });
    const { tooltipProps } = useTooltip$1({
        ...options,
        isOpen: open
    }, state);
    return [
        {
            ...state,
            placement
        },
        {
            overlayProps,
            tooltipProps
        }
    ];
}

export { useTooltip };
//# sourceMappingURL=use-tooltip.js.map
